import areEqual from "fbjs/lib/areEqual";
import PropTypes from "prop-types";
import * as React from "react";

import { RegisterTableDataPasteFunction } from "../../MultiLine/TableDataPasteContext";
import { Colgroup } from "../Colgroup";

import { MultilineDataRow, Table } from "./StickyTableBodyMultilineData.styles";

interface Props {
    children: React.ReactNode;
    className: string;
    columnWidth: number[];
    height?: number;
    registerMultilinePasteFunc?: (func: RegisterTableDataPasteFunction) => void;
}

export class StickyTableBodyMultilineData extends React.Component<Props> {
    public static childContextTypes = {
        registerMultilinePasteFunc: PropTypes.func,
    };

    public shouldComponentUpdate(nextProps: Props): boolean {
        return this.props.height !== nextProps.height || !areEqual(this.props.columnWidth, nextProps.columnWidth);
    }

    public getChildContext = () => ({
        registerMultilinePasteFunc: this.props.registerMultilinePasteFunc,
    });

    public render(): JSX.Element {
        return (
            <tr style={{ height: this.props.height }}>
                <MultilineDataRow>
                    <Table data-type="multiline">
                        <Colgroup columnWidth={this.props.columnWidth} />
                        {this.props.children}
                    </Table>
                </MultilineDataRow>
            </tr>
        );
    }
}
